<script setup>
import {computed, ref} from "vue"
import PrinterSelect from "../layout/printer-select.vue";
import helpers from "@/lib/helpers";
import {useDocs} from "@/lib/useDocs";
import {faBookJournalWhills} from "@fortawesome/free-solid-svg-icons";

const {printDoc} = useDocs();

const props = defineProps({
  noCopies: Boolean,
  type: String,
  setting: String,
  message: String,
  url: [Object, Array],
  success: {
    type: String,
    default: 'Label printed'
  }
})

// Component ref's
const modalref = ref()
const printer_select = ref()

const save_printer = ref(false)
const printer = ref(null)
const copies = ref(1)
const form = ref({})

const error = ref()

const multi = computed(() => {
  return props.url.length && (props.url.length > 1)
})

const do_print = (url) => {
  return printDoc(printer.value, props.type, url, copies.value, true, {
    printer_type: props.setting,
    save_printer: save_printer.value,
    ...form.value,
  })
}
const print = async () => {
  if (multi.value) {
    try {
      await do_print(props.url[0])
    } catch (e) {
      error.value = e.message
      return;
    }

    let success = 0
    let index = 1
    const errors = []

    while (index < props.url.length) {
      const batch = props.url.slice(index, index + 3)
      await Promise.all(batch.map(async (b) => {
        try {
          await do_print(b)
        } catch (e) {
          errors.push(e.toString())
        }
      }))
      index += 3
    }
    if (errors.length === 0)
      helpers.toast(props.url.length + ' labels printed successfully')
    else {
      const success = props.url.length - errors.length
      helpers.alert(success + " label(s) printed, " + errors.length + ' label(s) failed to print')
    }
  } else {
    try {
      await do_print(props.url)
      helpers.toast(props.success)
    } catch (e) {
      console.log('error', e)
      error.value = e
      return
    }
  }

  if (save_printer.value)
    printer_select.value.loadSettings()

  modalref.value.close()
}
</script>

<template>
  <modal title="Print Label" ref="modalref">
    <div class="p-1">
      <b-alert variant="primary" show v-if="multi">Printing batch of {{ url.length }} labels</b-alert>

      <template v-if="error && error.name === 'PrintError'">
        <b-alert variant="danger" class="p-1" show v-if="error && error.remote_error">
          <div class="font-weight-bold">Remote Print</div>
          <small>{{ error.remote_error }}</small></b-alert>
        <b-alert variant="danger" class="p-1" show v-if="error && error.local_error">
          <div class="font-weight-bold">Local Print</div>
          <small>{{ error.local_error }}</small></b-alert>
      </template>
      <b-alert v-else-if="error" show class="p-1">{{ error.message }}</b-alert>

      <div class="mb-3" v-if="!!message">{{ message }}</div>
      <modal-row label="Copies" v-if="!multi && !noCopies">
        <b-input type="number" v-model="copies"/>
      </modal-row>
      <modal-row label="Printer">
        <div class="text-right mt-1">
          <b-form-checkbox inline v-model="save_printer" unchecked-value="0" value="1">Save Printer</b-form-checkbox>
        </div>
        <printer-select v-model="printer" :type="type" :setting="setting" ref="printer_select"/>
      </modal-row>

      <slot :form="form"/>
    </div>

    <template #footer>
      <b-button size="sm" @click="$refs.modalref.close()" variant="outline-secondary" style="min-width: 100px">Cancel
      </b-button>
      <b-button size="sm" @click="print" variant="outline-primary" class="ml-2" style="min-width: 100px">Print
      </b-button>
    </template>
  </modal>
</template>

<style scoped>

</style>